import { c as _c } from "react/compiler-runtime";
import "../styles/globals.css";
import { setBreadcrumbs } from "@navikt/nav-dekoratoren-moduler";
import { configureLogger } from "@navikt/next-logger";
import { type DehydratedState, HydrationBoundary, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { AppProps } from "next/app";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { createBreadcrumbs } from "@/breadcrumbs/breadcrumbs";
import { ErrorBoundary } from "@/components/error/ErrorBoundary";
import { TestScenarioSelector } from "@/components/testscenarioselector/TestScenarioSelector";
import { minutesToMillis } from "@/utils/dateUtils";
import { getTestScenario, setTestScenario } from "@/utils/testScenarioUtils";
configureLogger({
  basePath: "/syk/aktivitetskrav"
});
function MyApp(t0) {
  const $ = _c(15);
  const {
    Component,
    pageProps
  } = t0;
  const {
    pathname
  } = useRouter();
  const [queryClient] = useState(_temp);
  let t1;
  let t2;
  if ($[0] !== pathname) {
    t1 = () => {
      setBreadcrumbs(createBreadcrumbs(pathname));
    };
    t2 = [pathname];
    $[0] = pathname;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const TestScenarioDevTools = _temp2;
  let t3;
  if ($[3] !== Component || $[4] !== pageProps) {
    t3 = <Component {...pageProps} />;
    $[3] = Component;
    $[4] = pageProps;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== pageProps.dehydratedState || $[7] !== t3) {
    t4 = <HydrationBoundary state={pageProps.dehydratedState}>{t3}</HydrationBoundary>;
    $[6] = pageProps.dehydratedState;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TestScenarioDevTools />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <main tabIndex={-1} id="maincontent">{t4}{t5}</main>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== queryClient || $[13] !== t6) {
    t7 = <ErrorBoundary><QueryClientProvider client={queryClient}>{t6}</QueryClientProvider></ErrorBoundary>;
    $[12] = queryClient;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp2() {
  if (process.env.NEXT_PUBLIC_RUNTIME_ENVIRONMENT === "local" || process.env.NEXT_PUBLIC_RUNTIME_ENVIRONMENT === "demo") {
    const hasActiveScenario = !!getTestScenario();
    if (!hasActiveScenario) {
      setTestScenario("FORHANDSVARSEL");
    }
    return <TestScenarioSelector />;
  }
  return null;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: minutesToMillis(30)
      }
    }
  });
}
export default MyApp;